import { useProductType } from '~/composables/useProductType';
import { useUpcPreselectConsolidated } from './useUpcPreselectConsolidated';
import { useUpcPreselectBasic } from './useUpcPreselectBasic';

export const useUpcPreselect = () => {
  const { query } = useRoute();

  const preselectedUpc = query?.upc_ID as string;

  if (!preselectedUpc) {
    return;
  }

  const { isConsolidatedMaster, isConsolidatedStandard } = useProductType();

  if (isConsolidatedMaster || isConsolidatedStandard) {
    useUpcPreselectConsolidated(preselectedUpc);
    return;
  }
  useUpcPreselectBasic(preselectedUpc);
};
